<template>
    <div>
        <div class="text-center">
            <h3 class="mt-0">Privacy Policy</h3>
            <p class="m-0">Activix Inc. ▪ Version 12.01</p>
            <p class="m-0">Effective date : December 1st 2017</p>
        </div>
        <div class="text-justify">
            <h4>1. Preamble</h4>
            <p>
                This Privacy Policy (hereinafter the "Policy") is a contract between you (meaning
                Activix Inc.'s User or the Activix Inc. Customer) linking to us (meaning Activix
                Inc. or any member or employee of Activix Inc.) and representing the voluntary
                agreement relating to the collection, use and disclosure of your personal
                information.
            </p>
            <p>
                IT IS IMPORTANT THAT YOU READ AND FULLY CONSIDER THE POLICY BEFORE CONSULTING OUR
                WEB SITE, BEFORE COMMUNICATING WITH US OR BEFORE CREATING AN ACCOUNT ON OUR
                PRODUCTS.
            </p>
            <p>
                By interacting with us, you agree and consent to the collection, use and disclosure
                of your personal information being governed by this Policy. The interactions covered
                by the Policy include, but are not limited to, the viewing and use of our web and
                other platform based products (hereinafter "Products") with the same name, and your
                communications with us.
            </p>
            <p>
                IF YOU DO NOT AGREE OR FULLY UNDERSTAND OUR POLICY, PLEASE STOP USING OUR PRODUCTS
                AND CONTACT THE AGENT RESPONSIBLE FOR THE PROTECTION OF PERSONAL INFORMATION
                DIRECTLY USING THE CONTACT INFORMATION AT THE END OF THIS PAGE.
            </p>
            <p>This preamble is an integral part of this Policy.</p>

            <h4>2. Consent</h4>
            <p>
                By providing us with your personal information, you authorize us to use and
                communicate it in connection with our services, to facilitate relations with
                Activix, its customers and users of the Products and that it is available to Activix
                employees, partners or agents, in the performance of their duties and for purposes
                directly related to the use, maintenance or updating of the Products, in accordance
                with this Policy and as permitted or required by law, as well as implicitly as
                indicated by the circumstances.
            </p>
            <p>
                Activix will seek your permission before using your personal information for
                purposes other than those covered by your original consent.
            </p>
            <p>
                You may withdraw your consent at any time, subject to legal and contractual
                restrictions and reasonable notice. If you provide us with personal information
                about another individual, you agree to have the necessary authorization to do so and
                / or that the users have obtained all the necessary consents from that individual to
                enable us to collect and use and disclose this personal information for the purposes
                set out in this Policy.
            </p>
            <p>
                You can withdraw your consent or ask to no longer receive electronic communication
                from us by writing to info@activix.ca
            </p>

            <h4>3. What personal information do we collect?</h4>
            <p>
                In addition to the personal information that we collect at the time of your
                registration (eg your surname, first name, address, telephone number and email
                address) as well as any other information required when browsing our Products (eg
                your geolocation data, payment-related information, etc.), we maintain the history
                of your interactions with the Products, including your notices, communications and
                publications on the Products.
            </p>
            <p>
                In addition, we use the Google Analytics Tool (hereinafter "Google") to obtain
                certain information about users of our Products. The information provided to us by
                Google is non-identifiable and is intended in particular to inform us about the
                demographic and geographic data of our users (eg age, sex, language, territory,
                etc.) and their behavior on our Products as well as that their affinities (eg
                lifestyle) and finally also informs us about the technology used by them in order to
                access our Products (eg browser, operating system, devices used, IP address, etc.).
            </p>

            <h4>4. What technology do we use to collect your personal information?</h4>
            <p>
                When you use our Products, we keep the history of your interactions on our server.
            </p>
            <p>
                As for the information collected by our audience analysis tool, Google proceeds by
                including a number in your browser using a
                <a href="https://support.google.com/adwords/answer/2407785">sample file</a>
                to remember your visit. This then allows Google to associate your browser with a
                demographic category to which you appear to belong based on other sites you visit.
                Google also uses your IP address to identify the country, region and city in which
                your computer connects to the Internet to access our Products. For more information
                on collecting your personal information, we invite you to visit Google's
                <a href="https://support.google.com/analytics/topic/2919631"
                    >Data Privacy and Security page</a
                >.
            </p>

            <h4>5. For what purposes do we use your personal information?</h4>
            <p>We use your personal information to fulfill the following purposes:</p>
            <ul>
                <li>
                    Get information on using the Products to increase and improve the user
                    experience;
                </li>
                <li>Offer web and mobile Products for your commercial usage;</li>
                <li>Collect statistics for later analysis;</li>
                <li>
                    Send emails to users of the Products and respond to requests made by these
                    users;
                </li>
                <li>
                    Provide users with information about the operation, news and services offered by
                    Activix, such as updates, our e-newsletter, changes to the Terms of Use or the
                    Policy;
                </li>
                <li>
                    Perform any other action necessary to protect the security or to ensure the
                    proper functioning of the Products.
                </li>
            </ul>
            <p>
                Unless otherwise stated, you should assume that any information you provide on the
                Products may be used for general solicitation or for commercial purposes and that
                such information may also be shared with our partners, affiliates, customers or
                suppliers with whom we have business relations.
            </p>

            <h4>6. How do we protect your personal information?</h4>
            <p>
                The entirety of our security measures cannot be divulged for obvious reasons.
                However, we may inform you that your personal information is stored on our servers
                and the content is protected by encrypted passwords that are regularly updated.
            </p>
            <p>
                Despite the security measures put in place to protect your personal information, no
                action is infallible.
            </p>
            <p>
                We undertake to give access to the Products data and its contents only to our
                employees, collaborators, subcontractors, directors and administrators who have a
                need to access it for the purpose of rendering services in connection with the
                Products, and they will be required to respect its confidentiality.
            </p>
            <p>
                BY NAVIGATING AND USING THE SERVICES PROVIDED ON THE PRODUCTS, YOU AGREE AND
                UNDERSTAND THE RISK THAT YOUR PERSONAL INFORMATION MAY BE UNLAWFULLY OBTAINED BY
                THIRD PARTIES AND / OR MALWARE SOFTWARE. CONSEQUENTLY, YOU DISCLAIM ANY REMEDY AND /
                OR CLAIM TO ACTIVIX INC., ITS SUBSIDIARIES, ASSOCIATES, ADMINISTRATORS OR
                SHAREHOLDERS IN THE EVENT OF THEFT OR MALICIOUS USE OF YOUR PERSONAL DATA BY ANY
                THIRD PARTY AND / OR MALWARE SOFTWARE.
            </p>

            <h4>
                7. Who are the people who have access to your personal information and who is this
                information shared with?
            </h4>
            <p>
                In addition to the information you share on the Products or that you share with
                other users, we are the only people who have access to your personal information.
                However, certain personal information may be shared with our partners or suppliers
                when your use of the Products requires it.
            </p>

            <h4>8. For how long do we keep your personal information?</h4>
            <p>
                We limit the retention of your personal information to a maximum of three (3) years
                following your use of the Products or the closure of your account, whichever is
                later.
            </p>

            <h4>
                9. Is it possible to limit the collection of your personal information when you use
                our Products?
            </h4>
            <p>
                Yes. You may limit the collection of your personal information at any time by
                installing the
                <a href="https://tools.google.com/dlpage/gaoptout/"
                    >Browser Add-on for disabling Google Analytics</a
                >. Several other ways to prevent or limit the collection of your personal
                information are also available on your
                <a href="https://support.google.com/analytics/answer/6004245"
                    >Google Privacy page</a
                >
                under the "Privacy Settings" tab.
            </p>
            <p>
                What's more, you can limit the collection of your personal information by disabling
                cookies in your browser and by
                <a href="www.allaboutcookies.org/fr/gerer-les-cookies/"
                    >denying permission requests</a
                >
                when you browse our Products, including your location.
            </p>

            <h4>
                10. How can you apply to find, update, modify or delete your personal information?
            </h4>
            <p>
                The protection of your personal information is a major concern for us. In doing so,
                we make available to you many ways to access, correct or delete your personal
                information in a timely manner, in particular through the page of your user profile.
            </p>
            <p>
                It is also your responsibility to contact the responsible agent in our organization
                to update or delete your information.
            </p>
            <p>
                For any additional requests in this area, please contact the responsible agent in
                our organization using the contact information at the bottom of this page.
            </p>

            <h4>
                11. How to apply for a change to your consent to the processing of your personal
                information?
            </h4>
            <p>
                You may withdraw your consent to the collection, use and disclosure of your personal
                information at any time subject to legal restrictions, a stipulation external to
                this Policy and a ten (10) business days notice to process your request.
            </p>
            <p>
                The request for modification must be made by email to the agent whose contact
                details appear at the bottom of this page. We will acknowledge receipt of your
                request by email. We may ask you to confirm your identity before providing this
                information. In principle, access to this information will be provided free of
                charge, but if you request a copy or transmission of your information, we may charge
                a reasonable fee. We will inform you of the amount in advance and give you the
                opportunity to withdraw your request. We will give users access to their information
                within ten (10) days of receiving their request or we will provide them with an
                email notification advising them that additional time is required to respond to
                their request.
            </p>
            <p>
                In some cases, we may be unable to provide access to information about you, in whole
                or in part. If we are unable to do so, or if the law does not allow it, we will
                provide an explanation and indicate the other measures available to you.
            </p>

            <h4>
                12. How can you complain about non-compliance with the principles of the Policy?
            </h4>
            <p>
                If you have any other comments or complaints about the protection of your personal
                information, please contact our agent directly using the contact information at the
                bottom of this page.
            </p>

            <h4>13. Update of the Privacy Policy without notice</h4>
            <p>
                This Policy is dynamic and is subject to change without notice. You cannot assume
                that it will remain the same and you agree to check the policy each time you visit
                the Products to see the changes. Your continued use of the Products demonstrates
                your acceptance of the provisions of this Policy and any changes.
            </p>
            <p>
                In making changes to our Policy, we are committed to using your personal information
                only for the purposes and for the purposes of this Privacy Policy when you provide
                us with your information or as required or permitted otherwise, unless you have
                expressly consented to do otherwise.
            </p>

            <h4>14. Is it possible that the Policy is not entirely followed?</h4>
            <p>
                Where permitted by law, and even as required by law, we may collect, use or
                disclose, in part or in whole, your personal information without your knowledge or
                consent. In such a case, we ensure that the collection, use and disclosure are in
                accordance with the law and seek rigorous legal advice to that effect. We reserve
                the right to challenge or respond to any request for the collection, use or
                disclosure of such personal information.
            </p>

            <h4>15. Disparity and interpretation</h4>
            <p>
                In case of disparity between the French version and the English version of this
                Policy, the French version prevails over any other version. This Policy is governed
                by the Site's Terms of Use in the event of a dispute or inconsistency with respect
                to such Policy.
            </p>

            <h4>
                16. Name and contact information of the agent responsible for the protection of
                personal information
            </h4>
            <p>
                For any request for access, correction, or deletion of your personal information, as
                well as for any comment, question or complaint in this area, we invite you to
                contact Olivier Tétrault, President, and agent responsible of the protection of
                personal information, by telephone at (438) 794-3432 or by email at info@activix.ca
                or by mail to 4965, rue Ambroise-Lafortune, suite 200, Boisbriand, Quebec J7H 0A4
            </p>
            <h4>17. Additional Limits on Use of Your Google User Data</h4>
            <p>
                Notwithstanding anything elsein this Privacy Policy, if you provide the App access
                to the following types of your Google data, the App's use of that data will be
                subject to these additional restrictions:
            </p>
            <ul>
                <li>
                    The App will only use access to read, write, modify or control Gmail message
                    bodies (including attachments), metadata, headers, and settings to provide a web
                    email client that allows users to compose, send, read, and process emails and
                    will not transfer this Gmail data to others unless doing so is necessary to
                    provide and improve these features, comply with applicable law, or as part of a
                    merger, acquisition, or sale of assets.
                </li>
                <li>The App will not use this Gmail data for serving advertisements.</li>
                <li>
                    The App will not allow humans to read this data unless we have your affirmative
                    agreement for specific messages, doing so is necessary for security purposes
                    such as investigating abuse, to comply with applicable law, or for the App's
                    internal operations and even then only when the data have been aggregated and
                    anonymized.
                </li>
            </ul>
        </div>
    </div>
</template>
